import generateUtilityClass from "../../utils/generateUtilityClass/generateUtilityClass.es.js";
import generateUtilityClasses from "../../utils/generateUtilityClasses/generateUtilityClasses.es.js";
function getPickersTextFieldUtilityClass(slot) {
  return generateUtilityClass("MuiPickersTextField", slot);
}
generateUtilityClasses("MuiPickersTextField", ["root", "focused", "disabled", "error", "required"]);
export {
  getPickersTextFieldUtilityClass
};
//# sourceMappingURL=pickersTextFieldClasses.es.js.map
